import { render, staticRenderFns } from "./remap-list.vue?vue&type=template&id=55229c54&scoped=true&"
import script from "./remap-list.vue?vue&type=script&lang=js&"
export * from "./remap-list.vue?vue&type=script&lang=js&"
import style0 from "./remap-list.vue?vue&type=style&index=0&id=55229c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55229c54",
  null
  
)

export default component.exports